import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5654675a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/historyDetails.scss?vue&type=style&index=0&id=5654675a&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=5654675a&lang=scss&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&id=5654675a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5654675a",
  null
  
)

export default component.exports